import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SmsConversationDialogComponent } from 'src/app/dialogs/sms/sms-conversation-dialog/sms-conversation-dialog.component';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { CNDocumentFile } from 'src/app/models/cndocumentfile';
import { CNDocumentReport } from 'src/app/models/cndocumentreport';
import { CNReport } from 'src/app/models/cnreport';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-contact-documents-row',
  templateUrl: './contact-documents-row.component.html',
  styleUrls: ['./contact-documents-row.component.scss']
})
export class ContactDocumentsRowComponent implements OnInit {

  public documents: CNDocumentReport[] | CNReport[] | CNDocumentFile[];

  private theContact: CNConsultation;
  public type: CNConsultationType;

  constructor(private dialog: MatDialog, private patientService: PatientService) { }

  ngOnInit(): void {
  }

  @Input() set contact(contact: CNConsultation) {
    this.theContact = contact;
    if (this.contact.getProperty('StVaast_Type')) {
      this.type = this.contact.getProperty('StVaast_Type');
    } else {
      this.type = CNConsultationType.Simple;
    }
    if (contact.documents) {
      this.documents = [];
      this.contact.documents.forEach(document => {
        // check if a request is linked with this document
        const requests = contact.requestsFor(contact.id.toString());
        if (requests) {
          document.requests = requests;
        }
        this.documents.push(document);
      });
    }
  }

  get contact(): CNConsultation {
    return this.theContact;
  }

  openDocument(document: CNDocumentReport | CNReport): void {
    const link = '/SN/StVaast/DocumentFile.php?reportid=' + document.id;
    window.open(link, '_report');
  }

  sendRXSMS(document: CNDocumentReport | CNReport): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
        patient: this.patientService.patient,
        message: "TEST SMS"
    };
    const dialogRef = this.dialog.open(SmsConversationDialogComponent, dialogConfig);
  }
}
